/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/artikel-with-aktionen.ts.
 */
import {Artikel} from './artikel';
import {ArtikelAktion} from './artikel-aktion';

/**
 * Zweck: Beschreibt class ArtikelWithAktionen und ihren Daten- oder Funktionsvertrag.
 */
export class ArtikelWithAktionen {
  artikel: Artikel;
  aktionen: ArtikelAktion[];
}
